import React from "react";

const ExpandCollapse = ({ collapsed, handleCollapse, handleExpand }) => {
  return (
    <a onClick={collapsed ? handleExpand : handleCollapse}>
      <i
        className={`fa ${collapsed ? "bi-plus-square-fill" : "bi-dash-square-fill"}`}
        title={collapsed ? `${window.i18n.t("source_menu.icon_popovers.expand")}` : `${window.i18n.t("source_menu.icon_popovers.collapse")}`}
      />
    </a>
  );
};

export default ExpandCollapse;
